import React, { useEffect, useState } from "react";
import { IoSearchOutline, IoWarning } from "react-icons/io5";
import { LuBadgeCheck } from "react-icons/lu";
import '../../css/items.scss';
import Dimmer from "../shared/Dimmer";
import './sponsors.scss';

const Sponsors = ({ data }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [sponsors, setSponsors] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);

    // serverInstance.get("/app/sponsors")
    //   .then(res => {
    //     let data = res.data.items.filter(item => !item.test)
    //     setFilteredData(data)
    //     setFilteredData(data)
    //     setErrorMsg("");
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     setErrorMsg(err);
    //     setLoading(false);
    //   })
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    const filtered = sponsors.filter((item) => {
      item.designated = (term === item.first_name.toLowerCase())
      return (
        (item.first_name.toLowerCase().includes(term)) ||
        (item.last_name.toLowerCase().includes(term)) ||
        (item.workplace && item.workplace.toLowerCase().includes(term)) ||
        (item.occupation && item.occupation.toLowerCase().includes(term)) ||
        (item.job && item.job.toLowerCase().includes(term))
      );
    });
    setFilteredData(filtered);
  };

  return (
    <div className='items-container' id='sponsors'>

      {loading ? <Dimmer /> : null}

      <section className="upper-section">
        <div className="upper-section-inner">
          <div className="title-container">
            <h2>{data.title}</h2>
          </div>

          <div className="input-container">
            <input
              type='text'
              placeholder={data.placeholder}
              value={searchTerm}
              onChange={handleSearch}
              className=''
            />
            <button className="search-btn">
              <IoSearchOutline size={18} />
            </button>
          </div>
        </div>
      </section>

      <section className='main-container'>
        {errorMsg ? <div className="error-msg">
          <IoWarning />
          &nbsp;
          {errorMsg}
        </div> : null}

        {loading ? null
          :
          filteredData?.length === 0?
            <div className="no-data">{data.noData}</div>
            :
            <div className="search-result">
              <div className="count">Хайлтын үр дүн: {filteredData.length}</div>

              <div className="items">
                {filteredData.map((item, index) => (
                  <div key={"sponsors" + index} className='sponsors-item'>
                    <div className='img-container'>
                      <div className={'rounded-circle d-flex justify-content-center align-items-center' + (item.paid === true ? ' paid' : item.fileUrl ? ' bordered' : '')}
                        style={{ objectFit: "cover", width: 120, height: 120 }}
                        >
                        <img src={item.fileUrl ? `https://lingo-portal-assets.s3.ap-northeast-2.amazonaws.com/${item.fileUrl}` : "/images/team/member.png"}/>
                      </div>
                      {item.designated ?
                        <div className="verified">
                          <LuBadgeCheck size={20} color="#22b861" />
                          <span>{data.verified}</span>
                        </div>
                        : null}
                    </div>
                    <div className='personal-info'>
                      <div className='name'>
                        {item.last_name.slice(0, 1)}.{item.first_name}
                      </div>
                      <div className='job'>{item.job || item.occupation}</div>
                      <div className='workplace'>{item.workplace}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
        }
      </section>
    </div>
  );
};

export default Sponsors;
